$(document).ready(function () {
//   console.log('running global desktop');
  var size = $('body').outerWidth();
  var ham_container = $('.header-drawer').css('display');
  // Open menu on mouse enter
  $('body').on('mouseenter', '.header__menu-item.list-menu__item', function () {
    if (ham_container === 'none') {
 //   console.log('hovered');
    $(this).attr('aria-expanded', 'true'); // Set aria-expanded to true
    $(this).parent('details').attr('open', true); // Open the parent <details> element
   // console.log('Added open characteristic to ' + $(this).parent().attr('id'));
    }
  });

  // Close menu on mouse leave (only if leaving the entire <details> block)
  $('body').on('mouseleave', 'details', function (event) {
     if (ham_container === 'none') {
    const $details = $(this);
    // Check if the mouse has completely left the <details> block
    if (!$(event.relatedTarget).closest('details').is($details)) {
  //    console.log('Mouse left details, closing...');
      $details.removeAttr('open'); // Close the <details> element
      $details.find('.header__menu-item.list-menu__item').attr('aria-expanded', 'false'); // Update aria-expanded to false
    }
     }
  });
  $('body').on('click','.icon-hamburger',function() {
      $('#MainContent').hide();
  });
  $('body').on('click','.menu-drawer-container .icon-close',function() {
     $('#MainContent').removeAttr('style');
  });
  $('body').on('click','.jdgm-all-reviews-text',function() {
     if ($('.jdgm-all-reviews-widget').css('display') === 'none') {
    $('.jdgm-all-reviews-widget').attr('style','display:block !important');
     }
     else {
      $('.jdgm-all-reviews-widget').removeAttr('style');
     }
  });
});
